/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const sinkBaseComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('SinkBase').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_LYNX_SBFDH_BODY',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('SinkBase').attach(memoEval((self)=>[
            self.$width
        ], ($width)=>({
            morphTargetInfluences: {
                Width: {
                    value: $width,
                    scaleZero: 24 * 25.4,
                    scaleOne: 48 * 25.4
                }
            }
        })))
];

//# sourceMappingURL=sink-base.js.map